// src/components/ui/progress.jsx

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "@/lib/utils";

const Progress = React.forwardRef(
  ({ className, value, variant = "default", showLabel = false, ...props }, ref) => {
    const progressValue = value || 0;
    
    // Determine color based on variant or value
    const getIndicatorClass = () => {
      if (variant === "success") return "bg-success";
      if (variant === "warning") return "bg-warning";
      if (variant === "danger") return "bg-danger";
      if (variant === "secondary") return "bg-secondary";
      
      // Default: change color based on value
      if (variant === "adaptive") {
        if (progressValue < 30) return "bg-danger";
        if (progressValue < 70) return "bg-warning";
        return "bg-success";
      }
      
      return "bg-primary";
    };

    return (
      <div className="relative">
        <ProgressPrimitive.Root
          ref={ref}
          className={cn(
            "relative h-2 w-full overflow-hidden rounded-full bg-neutral-light",
            className
          )}
          {...props}
        >
          <ProgressPrimitive.Indicator
            className={cn(
              "h-full w-full flex-1 transition-all duration-300 ease-in-out",
              getIndicatorClass()
            )}
            style={{ transform: `translateX(-${100 - progressValue}%)` }}
          />
        </ProgressPrimitive.Root>
        
        {showLabel && (
          <span className="absolute right-0 top-1/2 -translate-y-1/2 text-xs font-medium text-text ml-2">
            {Math.round(progressValue)}%
          </span>
        )}
      </div>
    );
  }
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
